import { Heading } from 'components/v2/Typography/Heading';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 24px;
  }
`;

export const TabHeading = styled(Heading).attrs({ styledAs: 'h2', tag: 'div' })`
  color: ${({ theme }) => theme.colors.neutral.lavenderWhite};
`;

export const Notice = styled.div`
  margin: 8px 0 16px;
  color: ${({ theme }) => theme.colors.neutral.lavenderWhite};
  font-size: 16px;
  line-height: 24px;

  a {
    color: inherit;
    text-decoration: underline;
  }

  p {
    margin: 0 0 16px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
